module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeAQMAAAAB/jzhAAAABlBMVEUAAAD/VS4A5Sn8AAAAAXRSTlMAQObYZgAAABZJREFUCNdjwA2YiSOY//8HE8TrIAwAUGYEM3e5PYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/module/basic/assets/img/ic_add.png
// module id = 294
// module chunks = 0